export const getLocalISODate = (date) => {
    const local = new Date(date);
    local.setHours(0, 0, 0, 0); // Sets to midnight in local time
    return local.toISOString().split('T')[0];
  };